import * as Yup from 'yup'

import { resalePriceOverwriteRuleSchema } from 'utils'

export const validationSchema = (isAddNew?: boolean) =>
  Yup.object({
    item: isAddNew ? resalePriceOverwriteRuleSchema : Yup.object(),
    list: Yup.array(resalePriceOverwriteRuleSchema),
  })
